// First-connection onboarding (#/onboarding, demo « Première connexion · exemple »). Session-local SIMULATION: no real account
// activation, no legal record, no browser permission. Two demo configurations: « facultative » (default) and « obligatoire »
// (#/onboarding?mode=obligatoire), where the initial bilan and the first guide become required. Steps move forward only on an
// explicit action; a missing required item is shown, never marked done. Shared state stays where it lives (account profile,
// consents and notification channel in compte-state; the initial bilan in bilan-state; the guides in the banque catalogue).
import { useSyncExternalStore } from "react";

export type Mode = "facultative" | "obligatoire";
export const STEP_COUNT = 7;
/** Guides of step 5: items of the shared catalogue (banque-fixtures), the first one required in the « obligatoire » mode. */
export const GUIDES = [
  { id: "p-bien-preparer-sa-seance-small-group", requiredIn: "obligatoire" as Mode | null },
  { id: "p-routine-respiration-avant-seance", requiredIn: null as Mode | null },
];

interface State {
  mode: Mode; step: number;
  profileChecked: boolean;
  conditions: boolean; consentsDecided: boolean;
  bilanLater: boolean;
  consulted: string[];
  notifDecided: boolean;
  completed: boolean;
}
const fresh = (mode: Mode): State => ({ mode, step: 0, profileChecked: false, conditions: false, consentsDecided: false, bilanLater: false, consulted: [], notifDecided: false, completed: false });
let state: State = fresh("facultative");
const listeners = new Set<() => void>();
export const onboarding = {
  get: () => state,
  subscribe: (l: () => void) => { listeners.add(l); return () => listeners.delete(l); },
  set: (patch: Partial<State>) => { state = { ...state, ...patch }; listeners.forEach(l => l()); },
  /** Explicit demo restart (also when the configuration in the route changes). */
  reset: (mode: Mode) => { state = fresh(mode); listeners.forEach(l => l()); },
};
export const useOnboarding = () => useSyncExternalStore(onboarding.subscribe, onboarding.get, onboarding.get);
/** Configuration explicitly requested by the route, or null when the route is bare (a return from a guide or the bilan): only an
 *  explicit mode parameter switches the configuration; a bare route keeps the current mode, step and answers. */
export const modeFromHash = (): Mode | null => { const m = window.location.hash.match(/mode=(obligatoire|facultative)/)?.[1]; return m ? m as Mode : null; };
